import { keyframes } from '@emotion/react';

import { iconSizes } from './styled';

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export interface ILoaderWithDots {
  size?: iconSizes;
  color?: string;
  marginRight?: number;
}

export default function LoaderWithDots({
  size = 20,
  color = '#4B5862',
  marginRight,
}: ILoaderWithDots) {
  return (
    <svg
      viewBox="0 0 24 24"
      role="img"
      aria-hidden="true"
      css={{
        height: size,
        width: size,
        marginRight,
        display: 'block',
        animation: `${rotate} 1s linear infinite`,
        transformOrigin: 'center center',
      }}
    >
      <g
        css={{
          fill: color,
        }}
      >
        <circle cx="12" cy="2" r="2" />
        <circle cx="2" cy="12" r="2" />
        <circle cx="22" cy="12" r="2" />
        <circle cx="12" cy="22" r="2" />
      </g>
    </svg>
  );
}
